import { Component } from '@angular/core';
import {
  FormControl,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import {
  SDSseachService,
  SearchListEntry,
  SearchList,
} from './sds-search.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApplicationUserService } from '../../applicationuser.service';
import { NotifierService } from 'angular-notifier';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { catchError, map, of } from 'rxjs';
import { Router } from '@angular/router';

interface DropdownEntry {
  name: string;
  code: string;
}

interface PageEvent {
  first: number;
  rows: number;
}

@Component({
  templateUrl: './sds-search.component.html',
  styleUrls: ['./sds-search.component.scss'],
})
export class SdsSearchComponent {
  countries: DropdownEntry[] = [];
  languages: DropdownEntry[] = [];
  languagesBackup: DropdownEntry[] = [];
  products: SearchListEntry[] = [];
  searchListResponse: Partial<SearchList> = {};
  firstIndex: number = 0;
  rows: number = 0;
  totalRecords: number = 0;
  // formGroup: FormGroup | undefined;
  columns: any[] = [];
  isDropdownsFetching = true;
  isSearchListFetching = true;
  searchFormValid: boolean = true;
  //   angForm: FormGroup=this.fb.group({
  //     name: ['', Validators.required ]
  //  });
  userDetails: any;
  sinequaProfile!: string;
  falseAlways:boolean =false;
  searchPerformed: boolean = false; // Flag to track if search has been performed
  searchForm: UntypedFormGroup = new UntypedFormGroup({
    selectedCountry: new UntypedFormControl('', []),
    selectedLanguage: new UntypedFormControl('', []),
    materialValue: new UntypedFormControl('',[]),
    textValue: new UntypedFormControl('', []),
  });
  currentSortField: string ='category.asc' ;
  sortOrder: 'asc' | 'desc' | null = null;
  currentField:string ='';
  pageNumber!:number;
  rowsPerPage: any;
  lastIndex!: number;
  isFirstTimeSearch = false;
  isLanguageFetching = true;
  constructor(
    private sdSseachService: SDSseachService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private userService: ApplicationUserService,
    private notifierService: NotifierService,
    private afAuth: AngularFireAuth,
    private router: Router
  ) {
    this.firstIndex = 0;
    this.rows = 10;
    this.columns = [
      // {
      //   name: 'Document Title',
      //   field: 'code',
      //   sortable: true
      // },

      {
        name: 'Product Name',
        field: 'category',
        sortable: true

      },
      {
        name: 'Country',
        field: 'quantity',
        sortable: false

      },
      {
        name: 'Language',
        field: 'quantity',
        sortable: false

      },
      {
        name: 'Version',
        field: 'quantity',
        sortable: false

      },
      {
        name: 'Material Code',
        field: 'quantity',
        sortable: false

      },
      {
        name: 'Date',
        field: 'date',
        sortable: false

      },
      {
        name: 'GBU Enterprise',
        field: 'gbuEnterprise',
        sortable: true

      },

      {
        name: 'Product Code',
        field: 'name',
        sortable: true

      },
      {
        name: 'Download',
        field: 'download',
        sortable: false
        ,
      },
    ];
  }

  handleGetDropdownValues() {
    this.isDropdownsFetching = true;

    this.sdSseachService.getDropdownValues().subscribe(
      (data) => {
        // Define the order of languages
        const languageOrder = ["EN (English)", "Z8 (EN (US) EHS ONLY)"];

        // Extract languages not in the defined order and sort them based on custom order
        const otherLanguages = data.Languages
          .filter(lang => !languageOrder.includes(lang))
          .sort((a, b) => languageOrder.indexOf(a) - languageOrder.indexOf(b)); // Custom sort function

        // Create the languages array with the desired order
        this.languages = [
          { name: 'Select a Language', code: '' },
          ...languageOrder.map(datum => ({ name: datum, code: datum })),
          ...otherLanguages.map(datum => ({ name: datum, code: datum }))
        ];
        this.countries = [{ name: 'Select a Country', code: '' }, ...data.Countries.map((datum) => ({ name: datum, code: datum }))];
      },
      () => {},
      () => {
        this.isDropdownsFetching = false;
        this.isLanguageFetching = false;
        this.searchForm.controls['textValue'].patchValue('');
      }
    );
  }


  handleGetSearchList(pageNumber?: number, fromManualSearch?: boolean) {

    const data = this.searchForm.getRawValue();
    if (fromManualSearch) {
      this.pageNumber = 1;
      this.isFirstTimeSearch = true;
    } else if (pageNumber) {
      // Update the page number from the paginator
      this.isFirstTimeSearch = false;
      pageNumber = this.pageNumber;
    } // If pageNumber is not provided, it keeps the current this.pageNumber
    if (fromManualSearch && ((data.materialValue === '' && data.textValue === ''))) {
      this.searchFormValid = false;

      // Check for multiple null values
      if (data.textValue.code === '' && data.textValue.code === '') {
        this.notifierService.notify('warning', 'Please search with either material code or product text before search.');
      }

      return;
    }
    this.searchFormValid = true;

    this.isSearchListFetching = true;
    if(this.currentSortField.includes('code')){
      this.currentField=this.currentSortField;
      this.currentSortField = this.currentSortField.replace('code','title');
    }
    if(this.currentSortField.includes('name')){
      this.currentField=this.currentSortField;
      this.currentSortField = this.currentSortField.replace('name','sourcestr2');
    }
    if(this.currentSortField.includes('category')){
      this.currentField=this.currentSortField;
      this.currentSortField = this.currentSortField.replace('category','sourcestr15');
    }
    if(this.currentSortField.includes('gbuEnterprise')){
      this.currentField=this.currentSortField;
      this.currentSortField = this.currentSortField.replace('gbuEnterprise','sourcestr3');
    }
    if(!this.searchPerformed || this.products.length==0){
      this.spinner.show();

    }
    this.sdSseachService
      .getSearchList({
        pageNumber: this.pageNumber,
        sinequaProfile: this.sinequaProfile,
        country:  data.selectedCountry.code,
        language: data.selectedLanguage.code,
        searchText: data.textValue,
        materialValue: data.materialValue,
        sort: this.currentSortField,
        isFirstTimeSearch: this.isFirstTimeSearch
      })
      .subscribe(
        (data) => {
          this.searchPerformed = true; // Set flag to true on successful search
          if (data?.Result?.Docs) this.products = [...data.Result.Docs];
          this.searchListResponse = data;
          this.handleSearchResponse(data);
          this.spinner.hide();

        },
        () => {},
        () => {
          this.isSearchListFetching = false;
          this.spinner.hide();

        }
      );
  }
// Method called after receiving the data
handleSearchResponse(data:any) {
  if(data.DocumentCount!=0){
    this.searchListResponse = data;
    this.products = data.Result.Docs;
    this.isSearchListFetching = false;
    // Update pagination details
    this.pageNumber = data.CurrentPage;
    this.totalRecords = data.DocumentCount;
    this.rowsPerPage = data.DocumentsPerPage;
    this.firstIndex = this.calculateFirstIndex(this.pageNumber, this.rowsPerPage);
    this.lastIndex = this.calculateLastIndex(this.pageNumber, this.rowsPerPage, data.DocumentsThisPage);
  }
  else{
    this.products=[];
  }
}

calculateFirstIndex(currentPage: number, rowsPerPage: number) {
  return (currentPage - 1) * rowsPerPage + 1;
}

calculateLastIndex(currentPage: number, rowsPerPage: number, documentsThisPage: number) {
  return this.calculateFirstIndex(currentPage, rowsPerPage) + documentsThisPage - 1;
}

  paginate(event: PageEvent): void {
    this.pageNumber = (event.first / event.rows) + 1;
    this.handleGetSearchList(this.pageNumber, false);
  }

  clearText() {
    this.searchForm.controls['textValue'].patchValue('');
    this.searchForm.controls['materialValue'].patchValue('');
    this.searchForm.controls['selectedCountry'].patchValue('');
    this.searchForm.controls['selectedLanguage'].patchValue('');
    this.searchForm.controls['textValue'].markAsPristine();
    this.isFirstTimeSearch = true;
    this.searchPerformed =false;
  }

  ngOnInit() {
    this.handleGetDropdownValues();
  }

  downloadSDS(Title:string,docId: string,productName: string,date:string,version:string,pdfTitle:string) {
    this.spinner.show();

    const parts = docId.split('|');
    const docID = parts[parts.length - 1];

    this.sdSseachService.getSdsDocument(
      { docId: docID,
        productName: productName,
        productTitle: Title,
        date: date,
        version : version,
        pdfTitle: pdfTitle
      }
      ).subscribe(
      response => {
        if (response && response.Base64Content) {
          this.downloadBase64File(pdfTitle,response.Base64Content, 'application/pdf');
        } else {
          console.error('No base64 content found in the response');
        }
      },
      error => {
        console.error('Error downloading document:', error);
      }
    );
  }

  private downloadBase64File(title: string,base64Content: string, contentType: string) {
    const byteCharacters = atob(base64Content);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = title+'.pdf';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
    this.spinner.hide();

  }
  onSort(field: string) {

    if (this.currentField.includes(field)) {
      if(this.currentSortField=='sourcestr15.asc'){
        this.currentSortField = 'sourcestr15.desc';
        this.handleGetSearchList(this.pageNumber, false);
        return
      }
      // Toggle sort order if the same field is sorted again
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      this.currentSortField = field + '.' + this.sortOrder;
    } else {
      // Set new field and default to ascending order
      this.sortOrder = 'asc';

      this.currentSortField = field + '.' + this.sortOrder;
    }
    this.handleGetSearchList(this.pageNumber, false);
  }

  //Reemoving selection of language from country field
  /*handleLanguageSelection(){
    this.isLanguageFetching = true;
    this.languagesBackup = this.languages;
    this.languages = [];
    const selectedCountryCode = this.searchForm.get('selectedCountry')?.value;

    if (selectedCountryCode) {

      this.sdSseachService.getLanguageDropdown(selectedCountryCode.code).subscribe(
        (data) => {
          // Add an empty entry to the beginning of the arrays
          this.languages = [{ name: 'Select a Language', code: '' }, ...data.Languages.map((datum) => ({ name: datum, code: datum }))];
        },
        () => {},
        () => {
          this.isDropdownsFetching = false;
          this.isLanguageFetching = false;
          this.searchForm.controls['textValue'].patchValue('');
        }
      );
    }
  }  */
}
